export default "__VITE_ASSET__B4zPg2PW__"